// Case-insensitive substring match för minimap/overview-sökning.
// Isolerad från komponentfilen så fast-refresh kan behandla
// `Minimap.tsx` som ren komponent-modul.

export interface SearchableBlock {
  id: string;
  config?: { name?: string };
}

/**
 * Match a block against a search query. Empty/whitespace-only queries
 * match everything. Looks at `config.name` first, then falls back to
 * the raw block id. Case-insensitive substring semantics.
 */
export function blockMatchesSearch(block: SearchableBlock, query: string): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  const name = (block.config?.name ?? '').toLowerCase();
  const id = block.id.toLowerCase();
  return name.includes(q) || id.includes(q);
}
